export default "__VITE_ASSET__Kb_a4B6e__"